import { jsx } from 'react/jsx-runtime';

const SvgAlertInfoFill = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M12 22c5.51 0 10-4.49 10-10S17.51 2 12 2 2 6.49 2 12s4.49 10 10 10Zm1-5h-2v-6h2v6ZM12 6.75a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5Z" }) }));

export { SvgAlertInfoFill as default };
//# sourceMappingURL=AlertInfoFill.es.js.map
